import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getAnalyticsConsent } from "@/components/analytics/ConsentBanner";

const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";

function getToken(): string | null {
  return localStorage.getItem("mfx_session");
}

// Cache location so we only look it up once per session
async function trackEvent(event: string, metadata?: Record<string, any>) {
  if (!getAnalyticsConsent()) return;
  const token = getToken();
  if (!token) return;

  // No browser-side location lookup. This previously called ipapi.co,
  // handing the user's IP to an undisclosed third party on every first
  // page view. Location for security purposes is now resolved
  // server-side from a local GeoLite2 database on login, so nothing is
  // lost and no client IP leaves our infrastructure.

  try {
    await fetch(`${BASE_URL}/api/v1/analytics/event`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ event, metadata }),
    });
  } catch {
    // Silent fail
  }
}

export function usePageTracking() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      prevPath.current = location.pathname;
      trackEvent("page_view", { path: location.pathname });
    }
  }, [location.pathname]);

  // Track initial page load
  useEffect(() => {
    trackEvent("page_view", { path: location.pathname });
  }, []);
}

export { trackEvent };
